<template>
  <div class="header">
    <el-row :gutter="50" class="header-top">
      <el-col :span="1" class="button">
            <!-- 侧边栏伸缩按钮 -->
            <i class="icon-menu" :class="isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="CHANGE_COLLAPSE"></i>
        </el-col>
      <!-- 播放操作视频 -->
      <el-col :span="1" class="video-col">
        <el-tooltip class="item" effect="dark" content="点击播放操作说明" placement="top"><el-button class="video-button" @click="openVideoDialog" icon="el-icon-video-play" type="text">
  </el-button>
</el-tooltip>

      </el-col>

      <!-- 弹窗显示视频 -->
      <el-dialog class="vedioDialog" :visible.sync="showDialog" :modal="false">
        <video v-if="currentVideo" controls autoplay class="vedioBox">
          <source :src="currentVideo" type="video/mp4" class="vedio">
          您的浏览器不支持 video 标签。
        </video>
      </el-dialog>

      <!-- 时间/logo标题 -->
      <el-col class="btn-menu" :span="1">
        <!-- 返回按钮 -->
        <el-button type="text" icon="el-icon-s-operation" class="exit" @click="centerDialogVisible = true"></el-button>
        <el-dialog :modal="false" title="提示" :visible.sync="centerDialogVisible" width="30%" center
          :append-to-body="true" :modal-append-to-body="false" :close-on-click-modal="false"
          :close-on-press-escape="false" custom-class="custom-dialog" style="margin-top:10%">
          <span align="center" style="display: block; font-size: 17px">此操作将选择回退的路径！</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="text" @click="quit(centerDialogVisible = false)"
              style="width: 30%; background-color: #71b9f4; color: rgb(255, 255, 255); padding: 7px;">退出登录</el-button>
               <el-button type="text" @click="jump(centerDialogVisible = false)"
            style="margin-left: 10%; width: 30%;background-color: #71b9f4; color: rgb(255, 255, 255); padding: 7px;">课程管理</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      centerDialogVisible: false,
      showDialog: false,  // 控制弹窗显示
    };
  },
  computed: {
    ...mapGetters(["isCollapse"]),
    ...mapState({
      currentVideo: state => state.currentVideo,
    }),
  },
  methods: {
    ...mapActions(["CHANGE_COLLAPSE"]),
    quit() {
      window.sessionStorage.removeItem("token");
      this.$router.push({
        path: "/login", // 修正路径为绝对路径
      });
      this.centerDialogVisible = false; // 关闭对话框
      this.$message({
        type: "success",
        message: "成功退出登录!",
      });
    },
    jump() {
      const userRole = window.sessionStorage.getItem('userRole');
      if (userRole === 2) {
        this.$router.push({
          path: "/stu_project",
        });
      } else {
        this.$router.push({
          path: "/project",
        });
      }
      this.centerDialogVisible = false; // 关闭对话框
    },
    ...mapActions([
      'setCurrentVideo',
    ]),
    // 判断当前页面并设置对应的视频
    openVideoDialog() {
      const currentPage = this.$route.name;

      let videoUrl = '';
      switch (currentPage) {
        case 'capManage':
          videoUrl = this.$store.state.videos.capManage;
          break;
        case 'probManage':
          videoUrl = this.$store.state.videos.probManage;
          break;
      }

      this.setCurrentVideo(videoUrl);
      this.showDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
#app.back-active {
  background-color: #d8ebf5;
}

.header-top {
  position: relative; /* 确保子元素能够相对定位 */
  height: 50px;
  background-color: rgb(46, 44, 44);
  z-index: 1000;
}

.header {
  width: 98%;
    background-color: #d8ebf5;
    margin-left: 25px;
}

/* 自定义对话框样式 */
.custom-dialog .el-dialog__wrapper {
  z-index: 10000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* 侧边栏收缩按钮 */
.icon-menu {
  cursor: pointer;
  font-size: 30px;
  color: #e1e6eb;
  position: absolute;
  top: 20px; /* 调整按钮向下移动的位置 */
}

/* 视频按钮 */
.video-col {
  position: absolute;
  top: 1%;
  right: 80px; /* 设置右上角位置 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-button {
  font-size: 36px; 
  color: #e1e6eb; 
  border: none; 
  background: transparent;
}

/* 退出按钮 */
.btn-menu {
  position: absolute;
  top: 1%;
  right: 40px; /* 设置退出按钮的右上角位置 */
}

.exit {
  font-size: 36px;
  color: #e1e6eb; 
  border: none; 
  background: transparent;
}

.vedioDialog {
  width: 100%;
  height: auto;
}

.vedioBox {
  width: 100%;
  height: auto;
  background-color: blue;
}
</style>
